export default {
    
    cities:         { method: 'get',    url: 'cities' },
    cityCreate:     { method: 'post',   url: 'cities'},
    cityUpdate:     { method: 'put',    url: 'cities/{id}'},
    cityDelete:     { method: 'delete', url: 'cities/{id}'},
    states:         { method: 'get',    url: 'states' },
}